import { render, staticRenderFns } from "./analysis-comments-card.vue?vue&type=template&id=218062d2&scoped=true"
import script from "./analysis-comments-card.vue?vue&type=script&lang=js"
export * from "./analysis-comments-card.vue?vue&type=script&lang=js"
import style0 from "./analysis-comments-card.vue?vue&type=style&index=0&id=218062d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218062d2",
  null
  
)

export default component.exports